import { useState, useEffect } from 'react';

// détecte si l'écran correspond au gabarit mobile (largeur <= breakpoint), et suit les changements de taille
// se base sur window.innerWidth (via resize) en plus de matchMedia, car certains outils d'émulation
// (ex: mode responsive de Firefox) ne déclenchent pas toujours l'évènement "change" de matchMedia
const useIsMobile = (breakpoint = 768) => {
    const [isMobile, setIsMobile] = useState(
        () => window.innerWidth <= breakpoint
    );

    useEffect(() => {
        const mql = window.matchMedia(`(max-width: ${breakpoint}px)`);
        const handleChange = () => setIsMobile(window.innerWidth <= breakpoint);
        mql.addEventListener('change', handleChange);
        window.addEventListener('resize', handleChange);
        return () => {
            mql.removeEventListener('change', handleChange);
            window.removeEventListener('resize', handleChange);
        };
    }, [breakpoint]);

    return isMobile;
};

export default useIsMobile;
